"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HorizontalScroll_1 = __importDefault(require("./HorizontalScroll"));
exports.default = HorizontalScroll_1.default;
